import React, { useState, useEffect } from 'react';
import { Grid, Checkbox, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MinusIcon from '@material-ui/icons/IndeterminateCheckBoxSharp';

import Tag from './Tag';

const useStyles = makeStyles((theme) => ({
  tagRow: {
    marginTop: theme.spacing(0.3),
    marginBottom: theme.spacing(0.3),
  },
  tagCheckbox: {
    width: '25px',
    height: '25px',
    cursor: 'pointer',
  },
}));

export default function TagSelection(props) {
  //
  // tags           List of tags which can be selected, as a list of tag objects
  // selected       List of tags which are currently selected, as a list of strings
  // indeterminate  If present, list of tags which are currently indeterminate.
  // setSelected    Called when the selection is changed via this control.  A single
  //                argument is passed, which is an object containing two members: tags,
  //                and tagsIndeterminate, each being a list of names of tags selected and
  //                indeterminate.
  //
  const { tags, selected, indeterminate, setSelected } = props;

  const classes = useStyles();

  async function onClick(event) {
    var tagName = '';
    if (typeof event === 'string') {
      tagName = event;
    } else {
      tagName = event.target.name;
    }

    const arraySel = selected.slice();
    const indexSel = arraySel.indexOf(tagName);
    var arrayInd = [];
    var indexInd = undefined;
    if (indeterminate) {
      arrayInd = indeterminate.slice();
      indexInd = arrayInd.indexOf(tagName);
    }
    if (indexSel > -1) {
      // Selected: Remove from selected
      arraySel.splice(indexSel, 1);
    } else if (indexInd > -1) {
      // Indeterminate: Remove from indeterminate, add to selected
      arrayInd.splice(indexInd, 1);
      arraySel.push(tagName);
    } else {
      // Neither: Add to selected
      arraySel.push(tagName);
    }
    setSelected({ tags: arraySel, tagsIndeterminate: arrayInd });
  }

  return (<>
    {tags.map((tag, i) => (
      <Grid container key={i}>
        <Grid item className={classes.tagRow}>
          <Tag
            label={tag.label}
            count={tag.count}
            tagType={tag.tagType}
            onClick={onClick}
          />
        </Grid>
        {selected.includes(tag.label) && (
          <Grid item>
            <Checkbox
              className={classes.tagCheckbox}
              checked={selected.includes(tag.label)}
              name={tag.label}
              onChange={onClick}
            />
          </Grid>
        )}
        {indeterminate && indeterminate.includes(tag.label) && (
          <Grid item>
            <IconButton
              className={classes.tagCheckbox}
              onClick={() => onClick(tag.label)}
            >
              <MinusIcon
                color='secondary'
              />
            </IconButton>
          </Grid>
        )}
      </Grid>
    ))}
  </>);
}
